module.exports = __webpack_public_path__ + "img/resources-768.dfe680da.jpg";